export const TypesMotivoPickupContainer = {
    CONTAINERALVO: "CONTAINERALVO",
    SERVICO: "SERVICO",
    LIMPARCONTAINERALVO: "LIMPARCONTAINERALVO",
    LIMPARSERVICO: "LIMPARSERVICO",
    RESETMOTIVOPICKUPCONTAINER: "RESETMOTIVOPICKUPCONTAINER",
}

const INITIAL = {
    containerAlvo: '',
    servico: {},
}

export default function motivoPickupContainerReducer(state = INITIAL, action) {

    switch (action.type) {
        case TypesMotivoPickupContainer.CONTAINERALVO:
            return {
                ...state,
                containerAlvo: action.payload.containerAlvo
            };
        case TypesMotivoPickupContainer.SERVICO:
            return {
                ...state,
                servico: action.payload.servico
            };
        case TypesMotivoPickupContainer.LIMPARCONTAINERALVO:
            return {
                ...state,
                containerAlvo: ''
            };
        case TypesMotivoPickupContainer.LIMPARSERVICO:
            return {
                ...state,
                servico: {}
            };
        case TypesMotivoPickupContainer.RESETMOTIVOPICKUPCONTAINER:
            return INITIAL;
        default:
            return state;
    }
}

export const MotivoPickupContainerActions = {
    setContainerAlvo,
    setServico,
    limparContainerAlvo,
    limparServico,
    resetStateMotivoPickupContainer,
}

function setContainerAlvo(container) {

    return {
        type: TypesMotivoPickupContainer.CONTAINERALVO,
        payload: { containerAlvo: container }
    }
}

function setServico(servico) {

    return {
        type: TypesMotivoPickupContainer.SERVICO,
        payload: { servico: servico }
    }
}

function limparContainerAlvo() {
    return { type: "LIMPARCONTAINERALVO" }
}

function limparServico() {
    return { type: "LIMPARSERVICO" }
}

function resetStateMotivoPickupContainer() {
    return { type: "RESETMOTIVOPICKUPCONTAINER" }
}